import React, {PureComponent} from 'react'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
//import GetAllFormFields from '../../../../components/_utils/formUtils'
import {FormUtils as GetAllFormFields} from 'sz-react-utils'
import {Button, Card, Form, notification, Tabs} from 'antd'
import _ from 'lodash'

import {hideLoader, showLoader} from '../../../../modules/actions'
import Request from '../../../../request'
import {connect} from 'react-redux'

const TabPane = Tabs.TabPane

// following variables needed for update country
let docLoaded = null
let countryId = null
let oldUniId = null

@Form.create()
class AddCampus extends PureComponent {
    callback = key => {
        let inputTypes = this.state.inputTypes

        if (countryId && inputTypes[key - 1] && !inputTypes[key - 1].opened) {
            inputTypes[key - 1].opened = true
            let tempObj = {}
            _.each(inputTypes[key - 1].fields, (v, k) => {
                tempObj[v.key] = docLoaded[v.key]
            })

            setTimeout(() => {
                this.props.form.setFieldsValue(tempObj)
            }, 10)
        }
    }
    handleSubmit = e => {
        const {dispatch, form} = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData)

                /*if (oldUniId != values.universityId) {
                    notification.error({
                      message: 'Invalid University',
                      description: 'Campus University cannot be changed'
                    })
                   return
                  }*/

                //values.oldUni=oldUniId;

                if (countryId) {
                    values = {...values, _id: countryId}

                    dispatch(showLoader())

                    let x = await Request.updateCampus(values)

                    dispatch(hideLoader())

                    if (!x.error) {
                        notification.success({
                            message: 'Success',
                            description: x.msg
                        })
                    } else {
                        notification.error({
                            message: 'Error Saving',
                            description: x.msg
                        })
                    }
                } else {
                    dispatch(showLoader())

                    let x = await Request.addCampus(values)

                    dispatch(hideLoader())

                    if (!x.error) {
                        notification.success({
                            message: 'Success',
                            description: x.msg
                        })

                        form.resetFields()

                        // dispatch('/all-countries')
                    } else {
                        notification.error({
                            message: 'Error Saving',
                            description: x.msg
                        })
                    }
                }
            }
        })
    }
    setFormValues = async countryId => {
        oldUniId = null

        try {
            let {doc} = await Request.getCampus(countryId);
            if (doc) {
                oldUniId = doc._id
                docLoaded = doc.campus
                docLoaded.universityId = oldUniId

                this.loadStates(docLoaded.campusCountryId)
                this.loadCities(docLoaded.campusStateId)

                let tempObj = {}

                let inputTypes = this.state.inputTypes

                _.each(inputTypes, (val, kk) => {
                    if (kk === 0) {
                        _.each(inputTypes[0].fields, (v, k) => {
                            if (v.key === 'universityId') {
                                v.disabled = true
                            }
                            tempObj[v.key] = docLoaded[v.key]
                        })
                    }
                })

                this.props.form.setFieldsValue(tempObj)
            }
        } catch (e) {
            console.log(e)
        }
    }
    loadUniversities = async () => {
        Request.loadSimpleUniversities({sort: {universityInstitutionName: 1}})
            .then(resp => {
                resp.arr = resp.arr.reduce((temp, vv) => {
                    temp.push({_id: vv._id, display: vv.universityInstitutionName})
                    return temp
                }, [])

                let inputTypes = this.state.inputTypes
                inputTypes[0]['fields'][0].options = resp.arr
                this.setState({inputTypes: inputTypes})
                this.refreshFxn()
            })
            .catch(err => {
                console.log(err)
            })
    }
    loadCountries = () => {
        let params = {sortField: 'countryName', sortOrder: 'ascend', results: 100}
        Request.getCountriesWithoutAuth({...params})
            .then(resp => {
                resp.data = resp.data.reduce((temp, vv) => {
                    temp.push({_id: vv._id, display: vv.countryName})
                    return temp
                }, [])
                let inputTypes = this.state.inputTypes
                inputTypes[0]['fields'][3].options = resp.data
                this.setState({inputTypes: inputTypes})
                this.refreshFxn()
            })
            .catch(err => {
                console.log(err)
            })
    }
    loadStates = id => {
        Request.loadStates(id)
            .then(daa => {
                daa.result = daa.result.reduce((total, val) => {
                    total.push({
                        _id: val._id,
                        key: val._id,
                        display: val.stateName
                    })
                    return total
                }, [])

                let inputTypes = this.state.inputTypes
                inputTypes[0]['fields'][4].options = daa.result
                this.setState({inputTypes: inputTypes})
                this.refreshFxn()
            })
            .catch(err => {
            })
    }
    loadCities = id => {
        Request.loadCities(id)
            .then(daa => {
                daa.result = daa.result.reduce((total, val) => {
                    total.push({
                        _id: val._id,
                        key: val._id,
                        display: val.cityName
                    })
                    return total
                }, [])
                let inputTypes = this.state.inputTypes
                inputTypes[0]['fields'][5].options = daa.result
                this.setState({inputTypes: inputTypes})
                this.refreshFxn()
            })
            .catch(err => {
            })
    }

    constructor(props) {
        super(props)
        this.state = {
            showSave: 1,
            showFiles: 0,
            refreshChild: false,
            inputTypes: [
                {
                    tabTitle: 'General Info',
                    fields: [
                        {
                            label: 'Select University ',
                            key: 'universityId',
                            required: true,
                            showSearch: true,
                            type: 'select',
                            disabled: false,
                            options: [],
                            onChange: v => {
                                this.props.form.setFieldsValue({
                                    universityId: v
                                })
                            }
                        },
                        {label: 'Campus Name', key: 'campusName', required: true},
                        {
                            label: 'Address',
                            key: 'universityWebsite',
                            type: 'textArea',
                            rows: 10,
                            required: true
                        },
                        {
                            label: 'Select Country ',
                            key: 'campusCountryId',
                            required: true,
                            type: 'select',
                            showSearch: true,
                            options: [],
                            onChange: v => {
                                this.props.form.setFieldsValue({
                                    campusCountryId: v,
                                    campusStateId: null,
                                    campusCityId: null
                                })
                                this.loadStates(v)
                            }
                        },
                        {
                            label: 'Select State',
                            key: 'campusStateId',
                            required: true,
                            showSearch: true,
                            type: 'select',
                            options: [],
                            onChange: v => {
                                this.props.form.setFieldsValue({
                                    campusStateId: v,
                                    campusCityId: null
                                })
                                this.loadCities(v)
                            }
                        },
                        {
                            label: 'Select City',
                            key: 'campusCityId',
                            showSearch: true,
                            required: true,
                            type: 'select',
                            options: [],
                            onChange: v => {
                                this.props.form.setFieldsValue({
                                    campusCityId: v
                                })
                            }
                        }
                    ]
                },
                {
                    tabTitle: 'Contact Details',
                    fields: [
                        {
                            label: 'Name',
                            key: 'campusNameOne',
                            prefixComp: <h3>Admission Person1</h3>
                        },
                        {label: 'Phone ', key: 'campusPhoneOne'},
                        {label: 'Email ', key: 'campusEmailOne'},

                        {
                            label: 'Name',
                            key: 'campusNameTwo',
                            prefixComp: <h3>Admission Person2</h3>
                        },
                        {label: 'Phone', key: 'campusPhoneTwo'},
                        {label: 'Email', key: 'campusEmailTwo'},

                        {
                            label: 'Name',
                            key: 'campusMarketingPersonName',
                            prefixComp: <h3>Marketing Person</h3>
                        },
                        {label: 'Phone', key: 'campusMarketingPersonPhone'},
                        {label: 'Email', key: 'campusMarketingPersonEmail'},

                        {
                            label: 'Name',
                            key: 'campusAccountPersonName',
                            prefixComp: <h3>Accounts Person</h3>
                        },
                        {label: 'Phone', key: 'campusAccountPersonPhone'},
                        {label: 'Email', key: 'campusAccountPersonEmail'}
                    ]
                }
            ]
        }

        this.loadCountries()
        this.loadUniversities()
    }

    componentDidMount() {
        let searchParams = new URLSearchParams(this.props.search)
        countryId = searchParams.get('id')
        if (countryId) {
            this.setState({showFiles: 1})
            this.setFormValues(countryId)
        }

        setTimeout(() => {
        }, 2000)
    }

    refreshFxn = () => {
        this.setState({refreshChild: !this.state.refreshChild})
    }

    render() {
        const {
            form: {getFieldDecorator}
        } = this.props

        return (
            <PageHeaderWrapper title={(countryId?'Edit':'Add New') + ' Campus'}>
                <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
                    <Card bordered={true}>
                        <Button
                            type="primary"
                            htmlType="submit"
                            style={{marginBottom: 10}}
                            loading={this.props.loading}>
                            SAVE
                        </Button>
                        <Tabs onChange={this.callback} type="card">
                            {this.state.inputTypes.map((itype, key) => {
                                return (
                                    <TabPane tab={itype.tabTitle} key={key + 1}>
                                        <GetAllFormFields
                                            inputSchema={this.state.inputTypes[key]}
                                            refresh={this.refreshFxn}
                                            getFieldDecorator={getFieldDecorator}
                                        />
                                    </TabPane>
                                )
                            })}
                        </Tabs>
                    </Card>
                </Form>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddCampus)
